import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { BellOutlined } from "@ant-design/icons";
import { selectNonCompletedRequests } from "../../selectors";
import { getRequestsToApprove } from "../../actions/api";

const MembershipRequestsLink = () => {
  const requests = useSelector(selectNonCompletedRequests);
  const dispatch = useDispatch();

  useEffect(() => {
    const pollInterval = setInterval(() => {
      dispatch(getRequestsToApprove());
    }, 60000);

    return () => clearInterval(pollInterval);
  }, [dispatch]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
      <NavLink
        to="/requests"
        style={({ isActive }) => ({
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: isActive ? "bold" : "normal",
        })}
      >
        <BellOutlined />
        <span>( {requests.length} ) Requests</span>
      </NavLink>
    </div>
  );
};

export default MembershipRequestsLink;
